//card
import { Card, CardContent, CardActions } from "@mui/material"
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import github from "./images/github.png";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as React from 'react';
import Collapse from '@mui/material/Collapse';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

const XpCard = (props) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Card sx={{ maxWidth: 370,backgroundColor:"#e1e8ee"}}>
            <CardContent>
                <Typography sx={{ fontSize: 14 }} gutterBottom>
                    {props.Date}
                </Typography>
                <Typography variant="h5" component="div">
                    {props.Name}
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    {props.Company}
                </Typography>
                <Typography variant="body2">
                    {props.Intro}
                </Typography>
            </CardContent>
        </Card>
    )
}
XpCard.defaultProps = {
    Id: null,
    Name: null,
    Link: null,
    Details: null,
    Date: "",
    Skills: null,
    Company: null,
};

XpCard.propTypes = {
    Id: PropTypes.number,
    Name: PropTypes.string,
    Link: PropTypes.string,
    Details: PropTypes.string,
    Date: PropTypes.string,
    Skills: PropTypes.string,
    Company: PropTypes.string,

};
export default XpCard